import { AspectRatio, Box, Heading, Tag, TagLeftIcon, TagLabel, Image, Text, Link, TextProps } from '@chakra-ui/react'
import { MdOutlineMedicalServices } from 'react-icons/md'
import Card from './Card'
import NextLink from 'next/link'
import { stripHtml } from 'string-strip-html'

interface SpecialistCardProps {
  specialist: Record<string, any>
}

interface TruncatedTextProps extends TextProps {
  maxLength: number
  children: string
}

const TruncatedText = ({ maxLength, children, ...rest }: TruncatedTextProps) => {
  const shouldTruncate = children.length > maxLength
  const content = children.length > maxLength ? children.substring(0, maxLength) : children

  if (shouldTruncate) {
    return (
      <Text {...rest}>
        {content}... <Link color="blue.500">Czytaj więcej</Link>
      </Text>
    )
  }

  return <Text {...rest}>{content}</Text>
}

const SpecialistCard = ({ specialist }: SpecialistCardProps) => {
  const photo = specialist.attributes?.photo?.data
  const speciality = specialist.attributes?.speciality?.data
  const description = stripHtml(specialist.attributes.description).result

  return (
    <Card>
      {photo && (
        <NextLink href={`/specjalista/${specialist.attributes.slug}`} passHref>
          <AspectRatio ratio={1.5} cursor="pointer">
            <Image src={photo.attributes.url} alt={specialist.attributes.fullName} />
          </AspectRatio>
        </NextLink>
      )}
      <Box padding="1rem">
        <Text>{specialist.attributes.title}</Text>
        <NextLink href={`/specjalista/${specialist.attributes.slug}`} passHref>
          <Heading size="md" marginTop="0.25rem" cursor="pointer">
            {specialist.attributes.fullName}
          </Heading>
        </NextLink>
        <NextLink href={`/specjalista/${specialist.attributes.slug}`} passHref>
          <TruncatedText marginTop="0.5rem" whiteSpace="pre-line" lineHeight={1.7} cursor="pointer" maxLength={136}>
            {description}
          </TruncatedText>
        </NextLink>
        {speciality && (
          <NextLink href={`/specjalnosc/${speciality.attributes.slug}`} passHref>
            <Link>
              <Tag variant="subtle" colorScheme="cyan" marginTop="1rem" size="lg" borderRadius={0}>
                <TagLeftIcon as={MdOutlineMedicalServices} />
                <TagLabel>{speciality.attributes.name}</TagLabel>
              </Tag>
            </Link>
          </NextLink>
        )}
      </Box>
    </Card>
  )
}

export default SpecialistCard
